import { ResourceType } from '../../shared/resource-type';

/**
 * The resource type for PublicationRequest
 */
export const PUBLICATION_REQUEST = new ResourceType('publicationrequest');
